exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-checkbox {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.form-checkbox .checkbox {\n  position: relative;\n  width: 60px;\n  height: 30px;\n\n  margin-left: 6px;\n  background-color: grey;\n}\n.form-checkbox .checkbox.active {\n  background-color: black;\n}\n.form-checkbox .checkbox .slider {\n  position: absolute;\n  left: 3px;\n  top: 3px;\n\n  width: 24px;\n  height: 24px;\n\n  background-color: white;\n}\n.form-checkbox .active .slider {\n  left: 33px;\n}\n", ""]);

// exports
